import { createPromiseAction } from '@adobe/redux-saga-promise';
import { UPDATE_TRANSACTION_PIN } from '../types';

// Fetch user actions with promise action
export const updateTransactionPin = createPromiseAction(UPDATE_TRANSACTION_PIN);

